import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Social from './pages/Social';
import SessionSetup from './pages/SessionSetup';
import SessionTypeSelector from './pages/SessionTypeSelector';
import QuestionnaireSetup from './pages/QuestionnaireSetup';
import QuestionnaireResults from './pages/QuestionnaireResults';
import QuestionnaireEdit from './pages/QuestionnaireEdit';
import SpeedRunQuizSetup from './pages/SpeedRunQuizSetup';
import SpeedRunFacilitator from './pages/SpeedRunFacilitator';
import SpeedRunSummary from './pages/SpeedRunSummary';
import FacilitatorMain from './pages/FacilitatorMain';
import Participant from './pages/Participant';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Subscription from './pages/Subscription';
import Analytics from './pages/Analytics';
import AlternativesComparison from './pages/AlternativesComparison';
import MiroAlternative from './pages/MiroAlternative';
import SlidoAlternative from './pages/SlidoAlternative';
import { Toaster } from '@/components/ui/sonner';
import GoogleAdsTracker from '@/components/GoogleAdsTracker';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <GoogleAdsTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/alternatives/mentimeter-vs-pollar" element={<AlternativesComparison />} />
            <Route path="/alternatives/miro-alternative-pollar" element={<MiroAlternative />} />
            <Route path="/alternatives/slido-alternative-pollar" element={<SlidoAlternative />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/social" element={<Social />} />
            <Route path="/session/setup" element={<SessionTypeSelector />} />
            <Route path="/session-setup/idea-pool" element={<SessionSetup />} />
            <Route path="/session-setup/questionnaire" element={<QuestionnaireSetup />} />
            <Route path="/session-setup/speed-run-quiz" element={<SpeedRunQuizSetup />} />
            <Route path="/session/:sessionId/facilitator" element={<FacilitatorMain />} />
            <Route path="/speed-run/:sessionId/facilitator" element={<SpeedRunFacilitator />} />
            {/* Speed run summary route */}
            <Route path="/speed-run/:sessionId/summary" element={<SpeedRunSummary />} />
            <Route path="/facilitator/:sessionId" element={<QuestionnaireResults />} />
            <Route path="/facilitator/:sessionId/edit" element={<QuestionnaireEdit />} />
            <Route path="/participant/:sessionId" element={<Participant />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" duration={3000} />
      </div>
    </HelmetProvider>
  );
}

export default App;